<!-- <div class="reviewDialogContent"> -->
<div mat-dialog-title class="mat-modal__head">
    <div class="modal-header p-3 py-2 ">
        <!-- <h5 class="modal-title">Preview Attachment</h5> -->
        <a class="close py-2" mat-dialog-close aria-label="Close">
            <mat-icon>close</mat-icon>
        </a>
    </div>
</div>

<mat-dialog-content class="p-4 large">
    <!-- <ng-container *ngIf="!loading; else elseTemplate"> -->
    <div [hidden]="loading">
        <!-- Image -->
        <div *ngIf="IsImage && htmlString" class="text-center">
            <img [src]="htmlString" alt="" style="max-width: 100%;max-height: 500px; object-fit: contain;" />
        </div>

        <!-- Video -->
        <div *ngIf="IsVideo && htmlString" class="text-center">
            <video [src]="htmlString" controls alt="Video Preview"
                style="max-width: 100%;max-height: 500px; object-fit: contain;"></video>
        </div>

        <!-- PDF  -->
        <div *ngIf="IsPdf && htmlString" class="text-center">
            <iframe [src]="htmlString" frameborder="0" style="width: 100%;height: 62vh;"></iframe>
        </div>

        <!-- Excel -->
        <div [hidden]="!IsExcel || !htmlString">
            <div class="preview-wrapper">
                <div class="sheet-tabs">
                    <button *ngFor="let name of sheetNames;let i=index" [class.active]="name === activeSheetName"
                        (click)="switchSheet(name)">
                        {{ name }}
                    </button>
                </div>
                <div #ExcelTableElement class="excel-container" [innerHTML]="htmlString | sanitizeHtml"></div>
            </div>
        </div>

        <!-- Word  -->
        <div [hidden]="!IsDoc">
            <div class="preview-wrapper">
                <div #WordTableElement></div>
            </div>
        </div>

        <!-- Other -->
        <div *ngIf="!IsImage && !IsVideo && !IsExcel && !IsPdf && !IsDoc && htmlString">
            <iframe [src]="htmlString" frameborder="0" style="width: 100%;height: 100%;"></iframe>
        </div>
    </div>
    <!-- </ng-container> -->
    <!-- <ng-template #elseTemplate> -->
    <div class="dataLoading" *ngIf="loading">
        <mat-spinner class="m-auto" diameter="50"></mat-spinner>
    </div>
    <!-- </ng-template> -->
</mat-dialog-content>
<!-- </div> -->
<mat-dialog-actions align="center" class="justify-content-center" *ngIf="!loading">
    <button mat-raised-button class="mat_orange_fill" (click)="onDownload()">Download</button>
</mat-dialog-actions>